import { useTheme } from '@chilipiper/design-system'
import { useMatchMedia } from '../../hooks/useMatchMedia'

export const useIsDesktop = () => {
  const { breakpoints } = useTheme()
  return useMatchMedia(`(min-width: ${breakpoints[1]})`)
}
